import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stepfinal',
  templateUrl: './stepfinal.component.html'
})
export class StepfinalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
